export const EMPTY_PAYMENT_METHOD = {
  attributes: {
    name: '',
    payment_type: '',
  },
}
